class LegacyVariantSelects extends HTMLElement {
  constructor() {
    (super(), this.addEventListener("change", this.onVariantChange));
  }
  connectedCallback() {
    const initialiseColour = () => {
      const groups = Array.from(this.querySelectorAll('.product-form__input'));
      const colour = groups.find(group => group.hasAttribute('data-fff-fixed-colour'));
      if (!colour) return;
      const index = groups.indexOf(colour);
      const variants = this.getVariantData();
      const pictured = variants.find(variant => /^as (pictured|shown)$/i.test(variant.options[index] || ''));
      const fallback = variants.find(variant => variant.available) || variants[0];
      const preferred = (pictured || fallback)?.options[index];
      if (!preferred) return;
      const select = colour.querySelector('select');
      const input = Array.from(colour.querySelectorAll('input[type="radio"]')).find(input => input.value === preferred);
      if (select && select.value !== preferred) {
        select.value = preferred;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (input && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseColour, { once: true });
    else queueMicrotask(initialiseColour);
  }
  onVariantChange() {
    (this.updateOptions(),
      this.updateMasterId(),
      this.toggleAddButton(!0, "", !1),
      this.updatePickupAvailability(),
      this.removeErrorMessage(),
      this.updateVariantStatuses(),
      this.currentVariant
        ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo(),
          this.updateShareUrl())
        : (this.toggleAddButton(!0, "", !0), this.setUnavailable()));
  }
  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (t) => t.value);
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (t) => !t.options.map((t, e) => this.options[e] === t).includes(!1),
    );
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    var t = this.currentVariant.featured_media.id;
    let e = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!e) return;
    let i = e.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    if ((e.prepend(i), document.querySelector(".product-slider"))) {
      var s = document.querySelector(
          ".product-slider .slick-track",
        ).childElementCount,
        r = [];
      for (let n = 0; n < s; n++)
        r.push(
          parseInt(
            document
              .querySelector(".product-slider")
              .querySelectorAll("li")
              [n].getAttribute("media-id"),
          ),
        );
      $(".product-slider").slick("slickGoTo", r.indexOf(t) - 1);
    } else if (document.querySelector(".product__media-list")) {
      var a = document.querySelector(".product__media-list").childElementCount;
      for (let o = 0; o < a; o++) {
        var l = document.querySelector(".product__media-list").children[o];
        l.getAttribute("data-media-id").indexOf(t) > 0
          ? (l.style.display = "block")
          : (l.style.display = "none");
      }
    }
  }
  updateURL() {
    this.currentVariant &&
      "false" !== this.dataset.updateUrl &&
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
  }
  updateShareUrl() {
    let t = document.getElementById(`Share-${this.dataset.section}`);
    t &&
      t.updateUrl &&
      t.updateUrl(
        `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
      );
  }
  updateVariantInput() {
    let t = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    t.forEach((t) => {
      let e = t.querySelector('input[name="id"]');
      ((e.value = this.currentVariant.id),
        e.dispatchEvent(new Event("change", { bubbles: !0 })));
    });
  }
  updateVariantStatuses() {
    let t = this.variantData.filter(
        (t) => this.querySelector(":checked").value === t.option1,
      ),
      e = [...this.querySelectorAll(".product-form__input")];
    e.forEach((i, s) => {
      if (0 === s) return;
      let r = [...i.querySelectorAll('input[type="radio"], option')],
        n = e[s - 1].querySelector(":checked").value,
        a = t
          .filter((t) => t.available && t[`option${s}`] === n)
          .map((t) => t[`option${s + 1}`]);
      this.setInputAvailability(r, a);
    });
  }
  setInputAvailability(t, e) {
    t.forEach((t) => {
      e.includes(t.getAttribute("value"))
        ? (t.innerText = t.getAttribute("value"))
        : (t.innerText = window.variantStrings.unavailable_with_option.replace(
            "[value]",
            t.getAttribute("value"),
          ));
    });
  }
  updatePickupAvailability() {
    let t = document.querySelector("pickup-availability");
    t &&
      (this.currentVariant && this.currentVariant.available
        ? t.fetchAvailability(this.currentVariant.id)
        : (t.removeAttribute("available"), (t.innerHTML = "")));
  }
  removeErrorMessage() {
    let t = this.closest("section");
    if (!t) return;
    let e = t.querySelector("product-form");
    e && e.handleErrorMessage();
  }
  renderProductInfo() {
    let t = this.currentVariant.id,
      e = this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section;
    fetch(
      `${this.dataset.url}?variant=${t}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
    )
      .then((t) => t.text())
      .then((i) => {
        if (this.currentVariant.id !== t) return;
        let s = new DOMParser().parseFromString(i, "text/html"),
          r = document.getElementById(`price-${this.dataset.section}`),
          n = s.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
          ),
          a = s.getElementById(
            `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
          ),
          o = document.getElementById(`Sku-${this.dataset.section}`),
          l = s.getElementById(
            `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
          ),
          d = document.getElementById(`Inventory-${this.dataset.section}`);
        (n && r && (r.innerHTML = n.innerHTML),
          l && d && (d.innerHTML = l.innerHTML),
          a &&
            o &&
            ((o.innerHTML = a.innerHTML),
            o.classList.toggle(
              "visibility-hidden",
              a.classList.contains("visibility-hidden"),
            )));
        let u = document.getElementById(`price-${this.dataset.section}`);
        (u && u.classList.remove("visibility-hidden"),
          d && d.classList.toggle("visibility-hidden", "" === l.innerText));
        let c = s.getElementById(`ProductSubmitButton-${e}`);
        (this.toggleAddButton(
          !c || c.hasAttribute("disabled"),
          window.variantStrings.soldOut,
        ),
          publish(PUB_SUB_EVENTS.variantChange, {
            data: { sectionId: e, html: s, variant: this.currentVariant },
          }));
      });
  }
  toggleAddButton(t = !0, e, i = !0) {
    let s = document.getElementById(`product-form-${this.dataset.section}`);
    if (!s) return;
    let r = s.querySelector('[name="add"]'),
      n = s.querySelector('[name="add"] > span');
    if (
      r &&
      (t
        ? (r.setAttribute("disabled", "disabled"), e && (n.textContent = e))
        : (r.removeAttribute("disabled"),
          (n.textContent = window.variantStrings.addToCart)),
      !i)
    )
      return;
  }
  setUnavailable() {
    let t = document.getElementById(`product-form-${this.dataset.section}`),
      e = t.querySelector('[name="add"]'),
      i = t.querySelector('[name="add"] > span'),
      s = document.getElementById(`price-${this.dataset.section}`),
      r = document.getElementById(`Inventory-${this.dataset.section}`),
      n = document.getElementById(`Sku-${this.dataset.section}`);
    e &&
      ((i.textContent = window.variantStrings.unavailable),
      s && s.classList.add("visibility-hidden"),
      r && r.classList.add("visibility-hidden"),
      n && n.classList.add("visibility-hidden"));
  }
  getVariantData() {
    return (
      (this.variantData =
        this.variantData ||
        JSON.parse(
          this.querySelector('[type="application/json"]').textContent,
        )),
      this.variantData
    );
  }
}
customElements.define("legacy-variant-selects", LegacyVariantSelects);
class LegacyVariantRadios extends LegacyVariantSelects {
  constructor() {
    super();
  }
  setInputAvailability(t, e) {
    t.forEach((t) => {
      e.includes(t.getAttribute("value"))
        ? t.classList.remove("disabled")
        : t.classList.add("disabled");
    });
  }
  updateOptions() {
    let t = Array.from(this.querySelectorAll("fieldset"));
    this.options = t.map(
      (t) =>
        Array.from(t.querySelectorAll("input")).find((t) => t.checked).value,
    );
  }
}
customElements.define("legacy-variant-radios", LegacyVariantRadios);
